import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/ApproveMarketplaceAffiliatePayout.graphql';
import { Mutation, MutationapproveMarketplaceAffiliatePayoutArgs } from '../../__generated__/globalTypes';

export const useApproveMarketplaceAffiliatePayoutMutation = (
  options?: MutationHookOptions<Mutation, MutationapproveMarketplaceAffiliatePayoutArgs>
) => {
  const [callApproveMarketplaceAffiliatePayout, result] = useMutation<
    Mutation,
    MutationapproveMarketplaceAffiliatePayoutArgs
  >(MUTATION, options);

  return { callApproveMarketplaceAffiliatePayout, ...result };
};

export type ApproveMarketplaceAffiliatePayoutMutationFunction = Mutation['approveMarketplaceAffiliatePayout'];
